
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLanguages } from "slices/languageSlice";
import Api from "services/api"
import toast from "react-hot-toast";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { Link } from "react-router-dom";
import { invoicesSelector } from "slices/invoiceSlice";
import { fetchAppointClientsListPage } from "slices/invoiceSlice";
import { userSelector } from "slices/userSlice";
import { fetchGeneratedInvoices } from "slices/invoiceSlice";
import { usePermissions } from "layouts/Admin";
import ConfirmationInvoice from "components/common/ConfirmationInvoiceGenerate";
const apiService = new Api();

function ClientInvoiceViewList() {
    const dispatch = useDispatch()
    const { checkPermission } = usePermissions();
    const { appointClientsListPage, generatedInvoices, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(invoicesSelector);
    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [generateInvoice, setGenerateInvoice] = React.useState(false);
    const [itemId, setItemId] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'asc',
    });
    const { user } = useSelector(userSelector);
    const userToken = user.token;

    React.useEffect(() => {
        dispatch(fetchAppointClientsListPage())
        dispatch(fetchGeneratedInvoices())
    }, [])

    const handleAddLanguagePopUp = (item) => {
        // setAddForm({
        //     show: true,
        //     item,
        // });
    };

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            dispatch(fetchAppointClientsListPage())
            hideConfirmDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const showGenerateInvoiceDialog = (id) => {
        setGenerateInvoice(true);
        setItemId(id)
    }
    const hideInvoiceDialog = () => {
        setGenerateInvoice(false);
    }
    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }

    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(appointClientsListPage?.map((val) => val.id.toString()))


    }


    //#region TABLE HEAD 

    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchAppointClientsListPage(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
        }
        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                    </div>
                </th>
                <th className="col-3">
                    <TableHeaderItem
                        title="Client Name"
                        sortBy="name"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th className="col-3">
                    <TableHeaderItem
                        title="Total Due Bill"
                        sortBy="name"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th className="col-3">
                    <TableHeaderItem
                        title="Number of Appointments"
                        sortBy="created_at"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                {(checkPermission('Detail Billing') || checkPermission('Generate Invoices')) &&
                    <th className="col-2">Actions</th>
                }

            </tr>
        )
    }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            appointClientsListPage?.map((item, index) => (
                <AppointClientItems invoice={generatedInvoices} data={item} userToken={userToken} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddLanguagePopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} showGenerateInvoiceDialog={showGenerateInvoiceDialog} />
            ))
        )
    }, [appointClientsListPage, selectedItems]);

    //#endregion


    return (
        <ListLayout
            time={false}
            addButtonDisabled={true}
            renderTableHeader={renderTableHeader}
            renderTableContent={renderTableContent}
            hideRemoveButton={true}
            invoiceButton={true}
            totalPages={totalPages}
            fetchList={fetchAppointClientsListPage}
            selectedItems={selectedItems}
            refAddutton={refAddutton}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            loader={loader}
            noOfItems={total}
            searchPlaceholder="Search..."
            >
            {generateInvoice && <ConfirmationInvoice onClose={hideInvoiceDialog} isOpen={generateInvoice} id={itemId}/>}
        </ListLayout>
    )

}


const AppointClientItems = ({
    data, index, current_page, pageLength ,checkPermission,showGenerateInvoiceDialog
}) => {
    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);
    const TotalDueBill = data?.appointments?.reduce((total, i) => total + (i?.invoice?.total_amount || 0), 0).toFixed(2);

    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{serial}</span>
                </div>
            </td>
            <td>
                {data?.user?.name}
            </td>
            <td>
                {TotalDueBill !== null && TotalDueBill !== undefined ? `${TotalDueBill}$` : 'N/A'}
            </td>
            <td>
                {data?.appointments?.length}
            </td>
            {(checkPermission('Detail Billing') || checkPermission('Generate Invoices')) &&
                <td>
                    <div className="row_check">
                        {checkPermission('Detail Billing') &&
                            <Link to={`/billings/detail/${data?.id}`} className="table_edit">Details</Link>
                        }
                        {checkPermission('Generate Invoices') &&
                            <button onClick={() => showGenerateInvoiceDialog(data?.id)} className="main_button text-nowrap">Generate invoice</button>
                        }
                    </div>
                </td>
            }
        </tr>
    )
}


export default ClientInvoiceViewList;
